<template>
  <div class="container_content">
    <!-- <nav-title>
      <div slot="title">风资源参数分析</div>
    </nav-title> -->
    <div class="content_nav-wrapper">
      <span
        @click="goUrl(item.path, key)"
        v-for="(item, key) in menus"
        :key="key"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == item.path }"
      >
        {{ item.name }}</span
      >
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        {
          name: '基本风况',
          path: '/wind-data/parameter-analysis/info'
        },
        {
          name: '风速变化',
          path: '/wind-data/parameter-analysis/speed'
        },
        {
          name: '风玫瑰图',
          path: '/wind-data/parameter-analysis/rose'
        },
        {
          name: '威布尔分布',
          path: '/wind-data/parameter-analysis/weibull'
        },
        {
          name: '湍流分析',
          path: '/wind-data/parameter-analysis/swift'
        },
        {
          name: '风切变',
          path: '/wind-data/parameter-analysis/shear'
        }
      ],
      activeIndex: ''
    };
  },
  methods: {
    goUrl(path) {
      this.activeIndex = path;
      this.$router.push({ path });
    }
  },
  created() {
    this.activeIndex = this.$route.path;
  }
};
</script>

<style lang="less" scoped>
.nav_wrapper {
  margin-top: 15px;
}
</style>
